import React from 'react';
import { useTranslation } from 'react-i18next';
import '../scss/account-action-modal.style.scss';

interface RemoveBankAccountModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const RemoveBankAccountModal: React.FC<RemoveBankAccountModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <div className="account-action-modal-overlay" onClick={onClose}>
      <div className="account-action-modal-container delete-modal-container" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="modal-header">
          <h2 className="modal-title">{t('REMOVE_BANK_ACCOUNT_TITLE')}</h2>
          <button className="modal-close-btn" onClick={onClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="#252525"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>

        {/* Body */}
        <div className="modal-body">
          {/* Warning Icon */}
          <div className="sad-message-badge">
            <span className="emoji">⚠️</span>
            <span className="message">{t('REMOVE_BANK_ACCOUNT_CONFIRMATION')}</span>
          </div>

          {/* Detailed Message */}
          <div className="modal-message delete-message">
            <p>
              {t('REMOVE_BANK_ACCOUNT_DESC_1')}
            </p>
            <p>
              {t('REMOVE_BANK_ACCOUNT_DESC_2')}
            </p>
            <p className="after-deletion-title">{t('REMOVE_BANK_ACCOUNT_CONFIRM_TITLE')}</p>
            <ul className="deletion-consequences">
              <li>{t('REMOVE_BANK_ACCOUNT_CONSEQUENCE_1')}</li>
              <li>{t('REMOVE_BANK_ACCOUNT_CONSEQUENCE_2')}</li>
            </ul>
          </div>

          <div className="modal-actions-group">
            <button className="modal-action-btn" onClick={handleConfirm}>
              <span>{t('REMOVE_BANK_ACCOUNT_BTN')}</span>
            </button>
            <button className="modal-cancel-btn" onClick={onClose}>
              <span>{t('CANCEL_BTN')}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RemoveBankAccountModal;
